/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
  function openTab(evt, cityName) {
    var i, tabcontent, tablinks; 
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
      tabcontent[i].classList.remove("active");
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    document.getElementById(cityName).classList.add("active");
    evt.currentTarget.className += " active";
  }
  if(jQuery("#defaultOpen").length > 0){
    document.getElementById("defaultOpen").click();
  }
  jQuery(".multi-video-click").click(function(){
    jQuery(this).parent().addClass('video_play');
    var iframe_id = '#' + jQuery(this).data('id');
    var symbol = jQuery(iframe_id)[0].src.indexOf("?") > -1 ? "&" : "?";
    var symbol = jQuery(iframe_id).data('src');
    jQuery(iframe_id)[0].src += symbol + "&autoplay=1";
    jQuery(iframe_id)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
  });
  var waitForEl = function(selector, callback) {
      if (jQuery(selector).length) {
          callback();
      } else {
          setTimeout(function() {
              waitForEl(selector, callback);
          }, 1000);
      }
  };
  var pageSize = 6;
  showPage = function(page, id) {
    jQuery(id + " .product-item").hide();
    jQuery(id + " .product-item").each(function(n) {
        if (n >= pageSize * (page - 1) && n < pageSize * page){
            jQuery(this).show();
        }
    });    
  }
  function load_data_tab(tab,search_wrapper,item_wrapper){
      waitForEl("#" + tab + ".active .product-item", function() {  
        var ttl_video_item = jQuery("#" +search_wrapper + " .product-item").length;
        if(ttl_video_item <= pageSize){ 
          /*jQuery("#" +search_wrapper + " a.static_pagination__next").hide();*/
          jQuery("#" +search_wrapper + " a.static_pagination__next, #" + tab + "pagination-numbers ").hide();
        }
        //showPage(1, '#video_search_result' );    
        jQuery("a.static_pagination__next ").click(function(e) {
          e.preventDefault();
          /*if (jQuery(this).parents("#" +search_wrapper).length != 0) {
             // showPage(parseInt(jQuery(this).attr('data-page')), '#video_search_result' );
          }else if (jQuery(this).parents('#manual_search_result').length != 0) {
              showPage(parseInt(jQuery(this).attr('data-page')), '#manual_search_result' );
          }*/
          var data_page = parseInt(jQuery(this).attr('data-page')) + 1;
          jQuery(".static_pagination__next").attr('data-page',data_page);
        });
        const paginationNumbers = document.getElementById(tab + "pagination-numbers");
        const paginatedList = document.getElementById(item_wrapper);
        const listItems = paginatedList.querySelectorAll("span"); 
        const nextButton = document.getElementById("next-button");
        const paginationLimit = 6; 
        const pageCount = Math.ceil(listItems.length / paginationLimit);  
        console.log('paginationLimit: '+ paginationLimit + ' pageCount :' + pageCount + ' listItems.length: ' + listItems.length)
        let currentPage = 1;
        const disableButton = (button) => {
          button.classList.add("disabled");
          button.setAttribute("disabled", true);
        };
        const enableButton = (button) => {
          button.classList.remove("disabled");
          button.removeAttribute("disabled");
        };
        const handlePageButtonsStatus = () => {
          /*if (currentPage === 1) {
            disableButton(prevButton);
          } else {
            enableButton(prevButton);
          }*/
          if (pageCount === currentPage) {
            disableButton(nextButton);
          } else {
            enableButton(nextButton);
          }
        };
        const handleActivePageNumber = () => {
          document.querySelectorAll(".pagination-number").forEach((button) => {
            button.classList.remove("active");
            const pageIndex = Number(button.getAttribute("page-index"));
            if (pageIndex == currentPage) {
              button.classList.add("active");
            }
          });
        };
        const appendPageNumber = (index) => {
          const pageNumber = document.createElement("button");
          pageNumber.className = "pagination-number";
          pageNumber.innerHTML = index;
          pageNumber.setAttribute("page-index", index);
          pageNumber.setAttribute("aria-label", "Page " + index);
          paginationNumbers.appendChild(pageNumber);
        };
        const getPaginationNumbers = () => {
          for (let i = 1; i <= pageCount; i++) {
            appendPageNumber(i);
          }    
        };
        const setCurrentPage = (pageNum) => {
          currentPage = pageNum;
          handleActivePageNumber();
          handlePageButtonsStatus();
          const prevRange = (pageNum - 1) * paginationLimit;
          const currRange = pageNum * paginationLimit;
          listItems.forEach((item, index) => {
            item.classList.add("hidden");
              item.style.display = 'none';
            if (index >= prevRange && index < currRange) {  console.log(index + ' crntindex ' + currRange);
              item.style.display = 'block';
              item.classList.remove("hidden");
            }
          });
        };
        /*window.addEventListener("load", () => {*/
          getPaginationNumbers();
          setCurrentPage(1);
          /*prevButton.addEventListener("click", () => {
            setCurrentPage(currentPage - 1);
          });*/
          nextButton.addEventListener("click", () => {
            setCurrentPage(currentPage + 1);
          });
          document.querySelectorAll(".pagination-number").forEach((button) => {
            const pageIndex = Number(button.getAttribute("page-index"));
            if (pageIndex) {
              button.addEventListener("click", () => {
                setCurrentPage(pageIndex);
              });
            }
          });
        /*});*/
      });
  }
  load_data_tab('videos-tab-result','video_search_result','video-paginated-list');
  load_data_tab('blog-tab-result','blog_search_result','blog-paginated-list');
jQuery(document).ready(function() {
  // Change the sorting to "Bestselling" for the "Shop all" collection
  jQuery('.collection-container [data-collection-title="Shop all"][data-collection-type="collection"]').find('.product-grid').data('sort-by', 'best-selling');

  // Trigger the collection re-sort
  jQuery('.collection-container').trigger('collection:sort');
});
